import { create } from '../../../utilities/action-helpers';
import * as actions from './actions';

// make one creator for each action in actions.js

export const setChangePasswordStatus = create(actions.SET_CHANGEPASSWORD_STATUS);
export const changePassword = create(actions.CHANGE_PASSWORD);
